module.exports = __webpack_public_path__ + "assets/img/btn-detail-0809ee81.png";